import { Badge, Button, Card, Col, Container, Form, ListGroup, ListGroupItem, Row, Stack, } from "react-bootstrap";
import Layout from "../../shared/components/Layout";
import Header from "../../shared/components/Header";
import { useNavigate, useSearchParams, } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAddons, fetchFeatureAddons, selectPlanById, selectPlansByPeriod, } from "../store/plansSlice";
import { useEffect, useState } from "react";
import { createOrder, recalcTotals, resetOrderEntity, setAddon, setBillingAddress, setPlan, updateAddonQty, setFeatureAddon } from "../store/orderEntitySlice";
import { useMemo } from "react";
import { cloneDeep } from "lodash";
import BillingAddress from "./BillingAddress";
import BillingAddressBlock from "../component/BillingAddressBlock";
import { UilEdit } from "@iconscout/react-unicons";
import Address1 from "../component/fields/Address1";
import Name from "../component/fields/Name";
import Address2 from "../component/fields/Address2";
import PhoneNumber from "../component/fields/PhoneNumber";
import City from "../component/fields/City";
import Pincode from "../component/fields/Pincode";
import State from "../component/fields/State";
import Gstin from "../component/fields/Gstin";

const CreateOrder = () => {
  const formatAmount = (val) => {
    const num = Number(val || 0);
    return num.toFixed(2);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const selectedPlan = searchParams.get("selected");

  const { accessToken } = useSelector((state) => state.auth);
  const user = useSelector((state) => state?.auth?.user);

  const planDetails = useSelector((state) =>
    selectPlanById(state, selectedPlan)
  );
  const { addons, featureAddons } = useSelector((state) => state.plans);
  const yearlyPlans = useSelector((state) =>
    selectPlansByPeriod(state, "yearly")
  );
  const { order_items, grand_total, tax_total, taxable_value, status, order_billing_addresses } =
    useSelector((state) => state.orderEntity);
  const { currentTenant } = useSelector((state) => state.sharedSlice);
  console.log("currentTenant", currentTenant)
  console.log("user", user)




  const orderEntity = useSelector((state) => state.orderEntity);
  const { addressSuccess } = useSelector((state) => state.orderEntity);
  const { currentPlan } = useSelector((state) => state.plans);
  // Normalize trial flag from current plan (handles 1, '1', true)
  const isTrialPlan = useMemo(() => {
    const flag = currentPlan?.plan?.is_trial;
    if (flag === true || flag === 1) return true;
    return String(flag) === '1';
  }, [currentPlan?.plan?.is_trial]);
  const isFreePlan = useMemo(
    () => String(currentPlan?.plan?.label || "").toLowerCase() === "free",
    [currentPlan?.plan?.label]
  );

  const [show, setShow] = useState(false);
  const [addlUsers, setAddlUsers] = useState(0);
  const [finalUsersCount, setFinalUsersCount] = useState(0);
  const [isEdit, setIsEdit] = useState(false)
  const userAddonPrice = addons[0]?.price;

  const availableFeatureAddons = useMemo(() => {
    const catalog = Array.isArray(featureAddons) ? featureAddons : [];
    const tenantFlavor = String(currentTenant?.flavor || "").toLowerCase();
    return catalog
      // only active addons
      .filter((fa) => fa && fa.status !== 0)
      // flavor must match current tenant, or be generic/both
      .filter((fa) => {
        const addonFlavor = String(fa.flavor || "").toLowerCase();
        if (!addonFlavor) return true; // treat empty as generic
        if (addonFlavor === "both") return true;
        return addonFlavor === tenantFlavor;
      });
  }, [featureAddons, currentTenant?.flavor]);

  // Plan features normalized by id and name, used only to block
  // selecting an add-on that is already included in the selected plan.
  const normalizeName = (v) => (typeof v === 'string' ? v : v?.name || '').toLowerCase();
  const { planFeatureNames, planFeatureIds } = useMemo(() => {
    const list = Array.isArray(planDetails?.features)
      ? planDetails.features
      : (Array.isArray(planDetails?.plan?.features) ? planDetails.plan.features : []);
    return {
      planFeatureNames: new Set(list.map((f) => normalizeName(f)).filter(Boolean)),
      planFeatureIds: new Set(list.map((f) => (typeof f === 'object' ? f?.id : null)).filter((v) => v != null)),
    };
  }, [planDetails]);

  const [selectedFeatureIds, setSelectedFeatureIds] = useState(new Set());
  const featureCatalog = availableFeatureAddons;
  const activeMultipleUsers = useMemo(() => {
    const selectedHas = featureCatalog.some(
      (f) => String(f?.name || '').toLowerCase() === 'multiple_users' && selectedFeatureIds.has(f.id)
    );
    const planFeatures = Array.isArray(planDetails?.features)
      ? planDetails.features
      : (Array.isArray(planDetails?.plan?.features) ? planDetails.plan.features : []);
    const alreadyActive = planFeatures.some((f) => normalizeName(f) === 'multiple_users');
    return selectedHas || alreadyActive;
  }, [featureCatalog, selectedFeatureIds, planDetails]);



  const billArray = {
    name: user?.name ? user?.name : null,
    phone_number: user?.phone ? user?.phone : null,
    address1: currentTenant?.business_address ? currentTenant?.business_address : null,
    address2: null,
    city: null,
    pincode: null,
    state: null,
    gstin: currentTenant?.gstin ? currentTenant?.gstin : null,
  }

  useEffect(() => {
    Object.entries(billArray).forEach(([key, value]) => {

      let data = {
        field: key,
        value: value,
      }
      dispatch(setBillingAddress(data));

    });
  }, []);

  useEffect(() => {
    if (addressSuccess) {
      // toast.success("Billing Address Added Successfully..!");
      setShow(false);
      setIsEdit(false)

    }
  }, [addressSuccess]);

  const handleBilling = () => {
    setShow(true);
  };

  // Load add-ons when auth/tenant context is ready
  useEffect(() => {
    if (!accessToken || !currentTenant?.id) return;
    dispatch(fetchAddons({ access_token: accessToken, tenant_id: currentTenant.id }));
    dispatch(fetchFeatureAddons({ access_token: accessToken, tenant_id: currentTenant.id }));
  }, [accessToken, currentTenant?.id]);

  useEffect(() => {
    dispatch(
      setAddon({
        addon_id: addons[0]?.id,
        price: addons[0]?.price,
      })
    );
  }, [addons]);

  // feature addons from API
  // moved earlier; keep single source of truth

  const isFeatureSelected = (id) => selectedFeatureIds.has(id);
  const handleToggleFeature = (addon) => {
    const newSet = new Set(selectedFeatureIds);
    if (newSet.has(addon.id)) {
      newSet.delete(addon.id);
      dispatch(setFeatureAddon({ addon, enabled: false }));
    } else {
      newSet.add(addon.id);
      dispatch(setFeatureAddon({ addon, enabled: true }));
    }
    setSelectedFeatureIds(newSet);
  };

  useEffect(() => {
    dispatch(
      setPlan({
        plan_id: planDetails?.id,
        price: planDetails?.price,
      })
    );
  }, [planDetails]);

  const handleNoOfUsersChange = (qty) => {
    dispatch(updateAddonQty(qty));
  };

  const handleAddlUsersChange = (qty) => {
    if (!activeMultipleUsers) {
      setAddlUsers(0);
      dispatch(updateAddonQty(0));
      return;
    }
    setAddlUsers(qty);
  };

  useEffect(() => {
    let finalQty = 0;
    if (activeMultipleUsers) {
      const includedUsers = parseInt(planDetails?.max_users);
      const currentUsers = parseInt(currentPlan?.subscription?.current_users);
      if (addlUsers) {
        finalQty = (currentUsers + parseInt(addlUsers)) - includedUsers;
        finalQty = finalQty < 0 ? 0 : finalQty;
      }
    }
    setFinalUsersCount(finalQty);
    dispatch(updateAddonQty(finalQty));
  }, [addlUsers, activeMultipleUsers])

  useEffect(() => {
    let finalQty = 0;
    if (activeMultipleUsers) {
      const includedUsers = parseInt(planDetails?.max_users);
      const currentUsers = parseInt(currentPlan?.subscription?.current_users);
      finalQty = currentUsers - includedUsers;
      finalQty = finalQty < 0 ? 0 : finalQty;
    }
    setFinalUsersCount(finalQty);
    dispatch(updateAddonQty(finalQty));
  }, [activeMultipleUsers])


  useEffect(() => {
    dispatch(recalcTotals());
  }, [order_items]);

  useEffect(() => {
    if (status) {
      if (status.success) {
        handlePayment();
      } else if (status.error) {
        alert(status.errorMessage);
        navigate("/plan/billing");
        dispatch(resetOrderEntity());
      }
    }
  }, [status]);

  const handleCreateOrder = () => {
    let orderData = cloneDeep(orderEntity);

    delete orderData.status;
    // delete orderData.order_billing_addresses;
    orderData.user_id = currentTenant?.pivot?.user_id;
    orderData.tenant_id = currentTenant?.id;
    orderData.subscription_id = currentPlan?.subscription?.id;
    if (
      orderData.order_billing_addresses &&
      orderData.order_billing_addresses.length > 0
    ) {
      const firstAddress = orderData.order_billing_addresses[0];
      const isEmptyAddress = Object.values(firstAddress).every(
        (value) => value === ""
      );

      if (isEmptyAddress) {
        delete orderData.order_billing_addresses;
      }
    }



    dispatch(
      createOrder({
        access_token: accessToken,
        data: orderData,
        tenantId:currentTenant?.id
      })
    );
  };

  const fetchRazorpayKey = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}tenants/razorpay-key`);
      const data = await response.json();
      return data.razorpay_key;
    } catch (error) {
      console.error('Error fetching Razorpay key:', error);
      return null;
    }
  };

  const handlePayment = async () => {
    let orderData = status.orderResponse;



    const RAZORPAY_KEY = await fetchRazorpayKey();
    if (!RAZORPAY_KEY) {
      console.error("Failed to fetch Razorpay key");
      return;
    }
    const amountInPaise = parseInt(orderData?.grand_total * 100);
    const planId = orderData?.order_items[0]?.plan_id;

    const options = {
      key: RAZORPAY_KEY,
      currency: "INR",
      amount: amountInPaise,
      name: user.name,
      description: "Payment for order " + orderData?.order_number,
      handler: async function (response) {


        try {
          const verifyResponse = await fetch(
            `${process.env.REACT_APP_API_URL}tenants/orders/confirm-payment`,
            {
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-Tenant": currentTenant?.id,
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify({
                order_id: orderData?.id,
                payment: {
                  reference_number: response.razorpay_payment_id,
                  amount: orderData?.grand_total,
                  status: response.razorpay_payment_id ? 'paid' : 'failed',
                  response: response,
                }
              }),
            }
          );

          const data = await verifyResponse.json();


          if (response.razorpay_payment_id) {
            alert("Payment processed successfully");
            navigate("/plan/billing");
            dispatch(resetOrderEntity());
            //window.location.reload();
          } else {
            alert("Payment process failed");
            navigate("/plan/billing");
            dispatch(resetOrderEntity());
          }
        } catch (error) {
          console.error("Error:", error);
          alert("Payment process failed");
        }
      },
      prefill: {
        name: user.name,
        email: user.email,
        contact: user.phone,
      },
      notes: {
        address: "Corporate Office",
        plan_id: planId,
      },
      theme: {
        color: "#F37254",
      },
    };

    const rzp1 = new window.Razorpay({
      ...options,
      modal: {
        ondismiss: function () {
          alert("Payment process was cancelled");
          navigate("/plan/billing");
          dispatch(resetOrderEntity());
        },
      },
    });
    rzp1.open(); // Directly open the Razorpay payment page
  };


  const handleEdit = () => {
    setIsEdit(true)
  }

  const total = (order_items[1]?.quantity || 0) * (addons[0]?.price || 0);
  const featureAddonsTotal = (order_items || [])
    .slice(2)
    .reduce((sum, it) => sum + (it.quantity * it.price), 0);

  return (
    <Layout>

      <Header
        title={"Change Billplus plan"}
        ItemActions={
          <Stack>
            <Button
              variant="outline-secondary"
              onClick={() => {
                navigate("/plan/billing/change-plan");
              }}
            >
              Back
            </Button>
          </Stack>
        }
      />
      <Container
        className=""
        fluid
        style={{
          height: "calc(100vh - 80px)",
          overflow: "auto",
          overflowX: "hidden",
        }}
      >
        {/* {!Object.values(order_billing_addresses[0]).some(value => value !== "") && !addressSuccess && <Col lg={12}>
          <Button variant="link px-0" onClick={handleBilling}>
            + Add Billing Address
          </Button>
        </Col>}
        {Object.values(order_billing_addresses[0]).some(value => value !== "") && addressSuccess && <Col lg={12}>
          <Button variant="link px-0 " onClick={handleEdit}>
            <UilEdit size="16" className="mx-2" />
            Edit
          </Button>
        </Col>}
        {Object.values(order_billing_addresses[0]).some(value => value !== "") && addressSuccess && <BillingAddressBlock />} */}
        <Row className="mt-2">
          <Col md={8}>
            <Card className="">
              <Card.Header className="border h4">
                Plan
              </Card.Header>

              <Card.Body className="p-2 border">
                <Card.Title className="text-center text-success"></Card.Title>
                <ListGroup variant="flush">
                  <ListGroupItem>
                    <div className="d-flex justify-content-between">
                      <div>
                        <Badge
                          className=""
                          bg="success"
                          style={{ fontSize: "20px" }}
                        >
                          {planDetails?.label}
                        </Badge>
                        <span className="mx-3">
                          ₹&nbsp;{formatAmount(planDetails?.price)} /{" "}
                          {planDetails?.period == "monthly" ? "Month" : "Year"}
                        </span>
                      </div>
                      <div>
                        <Button
                          variant="link float-end pe-0"
                          onClick={() => {
                            navigate("/billing/change-plan");
                          }}
                        >
                          Change
                        </Button>
                      </div>
                    </div>
                  </ListGroupItem>
                  <ListGroupItem
                    className="justify-content-between"
                    style={{ textTransform: "capitalize" }}
                    as={Stack}
                    gap={4}
                    direction="horizontal"
                  >
                    <div>
                      <span>Free Users In Plan(A) </span>

                    </div>
                    <span className="d-flex align-items-center">
                      {planDetails?.max_users}
                    </span>
                  </ListGroupItem>

                  <ListGroupItem
                    className="justify-content-between"
                    style={{ textTransform: "capitalize" }}
                    as={Stack}
                    gap={4}
                    direction="horizontal"
                  >
                    <div>
                      <span>Current Users(B) </span>

                    </div>
                    <span className="d-flex align-items-center">
                      {currentPlan?.subscription?.current_users}
                    </span>
                  </ListGroupItem>




                  {/* <ListGroupItem
                        className=""
                        style={{ textTransform: "capitalize" }}
                      ></ListGroupItem> */}
                </ListGroup>
              </Card.Body>
              <Card.Footer className="border">
                Total <span className="float-end">₹&nbsp;{formatAmount(planDetails?.price)}</span>
              </Card.Footer>
            </Card>

            <Card className="mt-5 mb-5">
              <Card.Header className="border h4">Addons</Card.Header>
              <Card.Body className="p-2 border">
                <Card.Title className="text-success">Additional Users</Card.Title>
                {activeMultipleUsers ? (
                  <ListGroup variant="flush" className="mb-3">
                    <ListGroupItem className="justify-content-between" as={Stack} gap={4} direction="horizontal">
                      <div>
                        <span>Additional Users(C)</span> (₹&nbsp;{formatAmount(userAddonPrice)} / User)
                      </div>
                      <span className="d-flex align-items-center">
                        <Form.Control
                          type="number"
                          className="mx-2 text-center"
                          style={{ width: "100px" }}
                          onChange={(e) => handleAddlUsersChange(e.target.value)}
                        />
                      </span>
                    </ListGroupItem>
                    <ListGroupItem className="justify-content-between" as={Stack} gap={4} direction="horizontal">
                      <div>
                        <span>Paid Users( B + C - A) </span>
                      </div>
                      <span className="d-flex align-items-center">{finalUsersCount}</span>
                    </ListGroupItem>
                  </ListGroup>
                ) : (
                  <ListGroup className="mb-3" variant="flush">
                    <ListGroupItem>
                      <small className="text-muted">To add more users, enable the Multiple Users add-on if available.</small>
                    </ListGroupItem>
                  </ListGroup>
                )}

                <Card.Title className="text-success">Available Feature Add-ons</Card.Title>
                <ListGroup variant="flush">
                  {featureCatalog.map((fa) => (
                    <ListGroupItem
                      key={fa.id}
                      className="d-flex justify-content-between align-items-center"
                      onClick={() => handleToggleFeature(fa)}
                      style={{ cursor: 'pointer' }}
                    >
                      <span>
                        <div className="fw-semibold">{fa.label}</div>
                        <div className="text-muted small">₹ {formatAmount(fa.price)} • Tax {fa.tax_rate}%</div>
                      </span>
                      <Form.Check type="checkbox" checked={isFeatureSelected(fa.id)} readOnly />
                    </ListGroupItem>
                  ))}
                  {featureCatalog.length === 0 && (
                    <ListGroupItem className="text-muted">No additional feature add-ons available.</ListGroupItem>
                  )}
                </ListGroup>
              </Card.Body>
              <Card.Footer className="border">
                <div className="d-flex justify-content-between">
                  <div>Users Total: ₹&nbsp;{formatAmount(userAddonPrice)} X {finalUsersCount}</div>
                  <div>₹&nbsp;{formatAmount(total)}</div>
                </div>
                <div className="d-flex justify-content-between mt-1">
                  <div>Feature Addons Total</div>
                  <div>₹&nbsp;{formatAmount(featureAddonsTotal)}</div>
                </div>
              </Card.Footer>
            </Card>

            <Card className="mb-5 mt-5 border">
              <Card.Header className="h4">Billing Address</Card.Header>
              <Card.Body className=" " style={{ borderTop: '1px solid lightgray' }}>
                <Row >
                  <Col lg={6} className="mt-3">
                    <Name />
                  </Col>
                  <Col lg={6} className="mt-3">
                    <PhoneNumber />
                  </Col>
                </Row>
                <Row >
                  <Col lg={6} className="mt-3">
                    <Address1 />
                  </Col>
                  <Col lg={6} className="mt-3">
                    <Address2 />
                  </Col>
                </Row>
                <Row >
                  <Col lg={6} className="mt-3">
                    <Gstin />
                  </Col>
                  <Col lg={6} className="mt-3">
                    <Pincode />
                  </Col>
                </Row>
                <Row >
                  <Col lg={6} className="mt-3"> <City /></Col>
                  <Col lg={6} className="mt-3">
                    <State />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="">
            <Card className="">
              <Card.Header
                className={`text-white`}
                style={{ background: "#00796B" }}
              >
                Summary
              </Card.Header>

              <Card.Body className="p-2 border">
                <Card.Title className="text-center text-success"></Card.Title>
                <ListGroup variant="flush">
                  <ListGroupItem
                    className=""
                    style={{ textTransform: "capitalize" }}
                  >
                    Total{" "}
                    <span className="float-end">₹&nbsp;{formatAmount(taxable_value)}</span>
                  </ListGroupItem>
                  <ListGroupItem
                    className=" "
                    style={{ textTransform: "capitalize" }}
                  >
                    Tax<span className="float-end">₹&nbsp;{formatAmount(tax_total)}</span>
                  </ListGroupItem>
                  <ListGroupItem
                    className="h4"
                    style={{ textTransform: "capitalize" }}
                  >
                    Grand total{" "}
                    <span className="float-end">₹&nbsp;{formatAmount(grand_total)}</span>
                  </ListGroupItem>
                </ListGroup>
              </Card.Body>
              <Card.Footer className="border h3 p-3">
                <span>
                  <Button
                    variant="primary float-end"
                    onClick={handleCreateOrder}
                  >
                    {status.success ? 'Redirecting to payment' : 'Proceed to pay'}
                  </Button>
                </span>
              </Card.Footer>
            </Card>
          </Col>
        </Row>

        {/* {show && <BillingAddress show={show} setShow={setShow} />}
        {isEdit && <BillingAddress show={isEdit} setShow={setIsEdit} isEdit={true} />} */}
      </Container>
    </Layout>
  );
};

export default CreateOrder;
